    <div class="auth-shell auth-shell-register">
      <aside class="auth-aside">
        <div class="auth-brand">
          <img class="auth-logo" src="/rectangular%20logo.PNG" alt="Central Profile" />
          <span class="eyebrow">Email-triggered reset</span>
          <h1 class="hero-title">Set a fresh password for your Central Profile access.</h1>
        </div>
      </aside>

      <section class="auth-panel">
        <div class="auth-card">
          <h2 class="page-title auth-title-reset">Reset password</h2>
          <form class="form-stack" [formGroup]="form" (ngSubmit)="submit()">
            <div class="input-group">
              <label for="newPassword">New password</label>
              <input id="newPassword" type="password" formControlName="password" />
            </div>
            <div class="input-group">
              <label for="confirmPassword">Confirm password</label>
              <input id="confirmPassword" type="password" formControlName="confirmPassword" />
            </div>
            <button class="btn btn-primary" type="submit">Reset password</button>
          </form>
        </div>
      </section>
    </div>
